<template>
	<el-container class="page-x" direction="vertical">
		<div class="search-x">
			<div class="search-item">
				<span class="label">供应商</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.keyword"
					placeholder="供应商名称、简称"
				></el-input>
			</div>

			<div class="search-item">
				<span class="label">状态</span>
				<el-select v-model="searchBox.status" clearable>
					<el-option
						v-for="item in statusArr"
						:value="item.value"
						:key="item.value"
						:label="item.label"
					></el-option>
				</el-select>
			</div>

			<div class="search-item">
				<span class="label">地区</span>
				<el-cascader
					ref="cascader"
					v-model="searchBox.areaId"
					@change="changeValue"
					clearable
					placeholder="请选择"
					:options="provinceList"
					:props="props"
				/>
			</div>

			<div class="search-item">
				<span class="label">服务类别</span>
				<el-cascader
					placeholder="请选择服务类别"
					clearable
					v-model="searchBox.serviceType"
					:options="serviceTypeList"
					:props="{
						value: 'id',
						label: 'name',
						emitPath: false,
					}"
				></el-cascader>
			</div>

			<div class="search-item">
				<span class="label">商务联系人</span>
				<el-input
					class="input-box"
					clearable
					v-model.trim="searchBox.contactUser"
					placeholder="商务联系人"
				></el-input>
			</div>

			<div class="search-item">
				<span class="label">合同时间</span>

				<el-date-picker
					v-model="timeRange"
					type="daterange"
					@change="toChangeTime"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期"
					value-format="timestamp"
					:default-time="['00:00:00', '23:59:59']"
				>
				</el-date-picker>
			</div>

			<!-- el-button v-auth="'sw_role_index'" v-auth属性展示是否有操作权限-->
			<el-button
				v-auth="'sa_provider_page'"
				type="primary"
				class="search-btn"
				@click="searchData"
				>查询</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_item_page'"
				type="primary"
				@click="() => ($root.showPage = false)"
				>重置</el-button
			>
			<el-button
				v-auth="'sa_provider_create'"
				type="warning"
				class="search-btn"
				@click="toAdd(null, 1)"
				>新建</el-button
			>
			<el-button
				class="search-btn"
				type="primary"
				@click="dialogVisibleImport = true"
				>批量导入</el-button
			>
			<el-button
				class="search-btn"
				v-auth="'sa_provider_export'"
				type="primary"
				@click="exportSupplier"
				>批量导出</el-button
			>
		</div>

		<div class="table-x table-b" ref="tableBox">
			<el-table
				v-loading="loading"
				:data="tableData"
				border
				:height="tableHeight"
				empty-text="未查找到相关供应商"
				class="mb20"
			>
				<el-table-column
					type="index"
					width="80px"
					align="center"
					label="序号"
				>
				</el-table-column>
				<el-table-column
					prop="providerName"
					align="center"
					label="供应商名称"
				>
				</el-table-column>
				<el-table-column
					prop="providerAbbr"
					align="center"
					label="供应商简称"
				>
				</el-table-column>
				<el-table-column prop="hospNum" align="center" label="网点数量">
				</el-table-column>
				<el-table-column
					prop="serviceNum"
					align="center"
					label="服务项目数量"
				>
					<template slot-scope="scope">
						{{ scope.row.serviceNum }}
						<el-tooltip
							v-if="scope.row.serviceNum > 0"
							placement="top"
							effect="light"
						>
							<div slot="content">
								{{ scope.row.serviceNames }}
							</div>
							<i class="el-icon-search"></i>
						</el-tooltip>
					</template>
				</el-table-column>

				<el-table-column align="center" label="合同时间">
					<template slot-scope="scope">
						{{
							scope.row.contractStartTime
								? handlingTime(scope.row)
								: ""
						}}
					</template>
				</el-table-column>
				<el-table-column
					prop="contactUser"
					align="center"
					label="商务联系人"
				>
					<template slot-scope="scope">
						<div
							v-for="(item, inx) in scope.row.contactExt"
							:key="inx"
						>
							{{ item.name }}
							{{ scope.row.contactExt.length > 1 ? "," : "" }}
						</div>
					</template>
				</el-table-column>

				<el-table-column label="状态" align="center" width="80px">
					<template slot-scope="scope">
						<!--  -->
						<div
							:class="
								scope.row.providerStatus == 'ON'
									? providerStatusFN(scope.row)
									: 'fontR'
							"
						>
							{{
								scope.row.providerStatus == "ON"
									? "启用"
									: "停用"
							}}
						</div>
					</template>
				</el-table-column>
				<el-table-column label="操作" width="240px" align="center">
					<template slot-scope="scope">
						<el-button-group>
							<el-button
								v-auth="'sa_provider_view'"
								type="text"
								size="middle"
								class="table-btn"
								@click="toAdd(scope.row, 0)"
								>查看</el-button
							>
							<el-button
								v-auth="'sa_provider_edit'"
								type="text"
								size="middle"
								class="table-btn"
								@click="toAdd(scope.row, 2)"
								>修改</el-button
							>
							<!-- <el-button v-auth="'sa_hospital'" type="text" size="middle" class="table-btn" @click="deletHandle(scope.row)">删除</el-button> -->
							<el-button
								v-auth="'sa_provider_status'"
								type="text"
								size="middle"
								class="table-btn"
								@click="changeStatus(scope.row)"
							>
								{{
									scope.row.providerStatus != "ON"
										? "启用"
										: "停用"
								}}
							</el-button>
							<el-button
								v-auth="'sa_hospital'"
								type="text"
								size="middle"
								class="table-btn"
								@click="goWebsite(scope.row)"
								>网点管理</el-button
							>
							<el-button
								v-auth="'sa_service'"
								type="text"
								size="middle"
								class="table-btn"
								@click="goService(scope.row)"
								>服务项目管理</el-button
							>
						</el-button-group>
					</template>
				</el-table-column>
			</el-table>
		</div>

		<!-- 分页部分 -->
		<div class="pagination">
			<el-pagination
				@current-change="handleCurrentChange"
				:current-page="searchBox.pageNo"
				@size-change="handleSizeChange"
				:page-sizes="[10, 50, 100]"
				:page-size="searchBox.pageSize"
				layout="total, sizes, prev, pager, next, jumper"
				:total="total"
				background
			>
			</el-pagination>
		</div>

		<!-- 新建、修改、查看弹层 -->
		<el-dialog
			append-to-body
			:title="dialogTitle"
			:visible.sync="dialogVisibleAdd"
			class="edit-dialog edit"
			:close-on-click-modal="false"
			@close="toCloseDialog"
		>
			<el-form
				ref="form"
				:model="formData"
				:rules="formRules"
				label-width="150px"
			>
				<el-form-item label="供应商名称" prop="providerName">
					<el-input
						v-model.trim="formData.providerName"
						:disabled="dialogType == 0"
						clearable
						placeholder="请输入供应商名称，限制50个字符"
						maxlength="50"
					></el-input>
				</el-form-item>

				<el-form-item label="供应商简称" prop="providerAbbr">
					<el-input
						v-model.trim="formData.providerAbbr"
						:disabled="dialogType == 0"
						clearable
						placeholder="请输入供应商简称，限制50个字符"
						maxlength="50"
					></el-input>
				</el-form-item>

				<!-- <el-form-item label="对接方式" prop="dockingMode">
          <el-radio-group
            v-model="formData.dockingMode"
            :disabled="dialogType == 0"
          >
            <el-radio label="ONLINE">线上</el-radio>
            <el-radio label="OFFLINE">线下</el-radio>
          </el-radio-group>
        </el-form-item> -->

				<el-form-item label="状态" prop="providerStatus">
					<el-radio-group
						v-model="formData.providerStatus"
						:disabled="dialogType == 0"
					>
						<el-radio label="ON">启用</el-radio>
						<el-radio label="OFF">停用</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- <el-form-item label="是否需要OCR解析" prop="ocrRequired">
                    <el-radio-group v-model="formData.ocrRequired" :disabled="dialogType==0">
                        <el-radio label="YES">是</el-radio>
                        <el-radio label="NO">否</el-radio>
                    </el-radio-group>
                </el-form-item> -->

				<el-form-item label="供应商描述" prop="providerDesc">
					<el-input
						v-model.trim="formData.providerDesc"
						:disabled="dialogType == 0"
						clearable
						show-word-limit
						placeholder="请输入供应商描述，限制300个字符"
						type="textarea"
						maxlength="300"
					></el-input>
				</el-form-item>

				<el-form-item label="供应商地址" prop="providerAddress">
					<el-input
						v-model.trim="formData.providerAddress"
						:disabled="dialogType == 0"
						clearable
						show-word-limit
						placeholder="请输入供应商地址，限制100个字符"
						type="textarea"
						maxlength="100"
					></el-input>
				</el-form-item>

				<el-form-item label="合同时间" prop="validityCache">
					<el-date-picker
						v-model="formData.validityCache"
						type="daterange"
						:disabled="dialogType == 0"
						@change="toChangeTimeAdd"
						range-separator="至"
						start-placeholder="开始日期"
						end-placeholder="结束日期"
						value-format="timestamp"
					>
					</el-date-picker>
				</el-form-item>

				<div v-for="(item, inx) in formData.contactExt" :key="inx">
					<el-form-item
						:label="'商务联系人' + (inx + 1)"
						:prop="'contactExt.' + inx + '.name'"
					>
						<el-input
							v-model.trim="item.name"
							:disabled="dialogType == 0"
							clearable
							placeholder="请输入商务联系人，限制10个字符"
							maxlength="10"
						></el-input>

						<el-button
							v-if="inx > 0"
							type="text"
							@click.prevent="removeContact(inx)"
							style="margin-left: 15px"
							>删除</el-button
						>
					</el-form-item>

					<el-form-item
						:label="'联系电话' + (inx + 1)"
						:prop="'contactExt.' + inx + '.mobile'"
					>
						<el-input
							v-model.trim="item.mobile"
							:disabled="dialogType == 0"
							clearable
							placeholder="请输入联系电话"
							type="tel"
							maxlength="11"
						></el-input>
					</el-form-item>

					<el-form-item
						:label="'联系邮箱' + (inx + 1)"
						:prop="'contactExt.' + inx + '.email'"
					>
						<el-input
							v-model.trim="item.email"
							:disabled="dialogType == 0"
							clearable
							placeholder="请输入联系邮箱"
							maxlength="50"
						></el-input>
					</el-form-item>
				</div>

				<el-form-item label="">
					<el-button
						:disabled="
							dialogType == 0 || formData.contactExt.length > 2
						"
						icon="el-icon-plus"
						@click="addContact"
						>继续添加联系人</el-button
					>
				</el-form-item>
			</el-form>

			<span slot="footer" class="dialog-footer" v-show="dialogType !== 0">
				<el-button class="search-btn" @click="toCloseDialog"
					>取 消</el-button
				>
				<el-button
					type="primary"
					class="search-btn"
					@click="addSupplier"
					:loading="submitLoading"
					>确定</el-button
				>
			</span>
		</el-dialog>

		<!-- 批量导入供应商 -->
		<el-dialog
			title="批量导入供应商"
			:visible.sync="dialogVisibleImport"
			center
			class="edit-dialog"
			:close-on-click-modal="false"
			@closed="toCloseDialogImport"
		>
			<el-form
				ref="templateForm"
				:model="templateForm"
				label-width="120px"
			>
				<el-form-item label="下载模板：">
					<el-button type="primary" class="search-btn"
						><a class="no-a" @click="downloadTemp">下载模版</a>
						<!-- ><a class="no-a" :href="`${path}excel/service.xlsx`">下载模版</a> -->
					</el-button>
				</el-form-item>

				<el-form-item label="选择上传文档：">
					<el-upload
						class="upload-dom"
						ref="upload-dom"
						:action="uploadAction"
						:headers="uploadHeader"
						:limit="1"
						:auto-upload="false"
						:on-change="uploadChange"
						:before-remove="uploadBeforeRemove"
						:on-success="uploadSucess"
						:on-remove="uploadHandleRemove"
						:before-upload="uploadBefore"
						accept=".xlsx,.xls"
						style="width: 55%"
					>
						<el-button type="primary" icon="el-icon-upload"
							>上传附件</el-button
						>
					</el-upload>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button class="search-btn" @click="toCloseDialogImport"
					>取消</el-button
				>
				<el-button
					class="search-btn"
					type="primary"
					@click="sureSubmit('templateForm')"
					>确定</el-button
				>
			</div>
		</el-dialog>
		<ImportFail
			:show="showImportFail"
			title="导入供应商"
			:failObj="errorData"
			@receive="getReceive"
		/>
	</el-container>
</template>

<script>
	import cascader from "@/assets/js/cascader.mixin";
	import getService from "@/mixins/getService.mixin";
	import db from "@/assets/js/localstorage";
	import { mapGetters } from "vuex";
	import { dateFormat } from "@/assets/js/until.js";
	import ImportFail from "./components/ImportFail";
	import _ from "loadsh";
	export default {
		name: "SupplierManager",
		mixins: [cascader, getService],
		components: {
			ImportFail,
		},
		beforeRouteEnter(to, from, next) {
			if (from.name != "ServiceManager" && from.name != "WebsiteManager") {
				next((vm) => {
					vm.$root.breadList = [
						{ name: "供应商", link: "" },
						{ name: "供应商管理", link: "" },
					];
					vm.searchBox = {
						keyword: "", // 模糊查询
						status: "", // 状态
						providerIdSet: "",
						providerId: to.params.id,
						pageNo: 1, // 页码
						pageSize: 10,
					};
					vm.getData();
					vm.listenWindow();
				});
			} else {
				next((vm) => {
					vm.$root.breadList = [
						{ name: "供应商", link: "" },
						{ name: "供应商管理", link: "" },
					];
					vm.getData();
					vm.listenWindow();
				});
			}
		},
		data() {
			let checkEmail = (rule, value, cb) => {
				if (value && !this._valid._limitemail(value)) {
					cb("请输入正确的邮箱");
				} else {
					cb();
				}
			};
			let checkPhone = (rule, value, cb) => {
				if (!value && rule.field == "contactExt.0.mobile") {
					cb("请输入联系电话");
				} else if (value && !this._valid._limitPhone(value)) {
					cb("请输入正确电话号码");
				} else {
					cb();
				}
			};

			return {
				timeRange: [], // 时间缓存
				// 时间缓存

				searchBox: {
					keyword: "", // 模糊查询
					status: "", // 状态
					providerIdSet: "",
					contractStartTime: "",
					contractEndTime: "",

					pageNo: 1, // 页码
					pageSize: 10,
				},
				statusArr: [
					{ value: "ON", label: "启用" },
					{ value: "OFF", label: "停用" },
				],
				total: 0,
				tableHeight: 0,
				loading: false,
				tableData: [],

				dialogTitle: "新增供应商",
				dialogVisibleAdd: false, //新建、修改弹层
				dialogType: 1, // 1：新增 2：编辑 0：查看
				formData: {
					providerName: "",
					providerAbbr: "",
					dockingMode: "",
					providerStatus: "ON",
					ocrRequired: "YES",
					providerDesc: "",
					providerAddress: "",
					contractStartTime: "",
					contractEndTime: "",
					validityCache: "",
					contactExt: [{ name: "", mobile: "", email: "" }],
				},
				formRules: {
					providerName: [
						{
							required: true,
							message: "请输入供应商名称",
							trigger: "blur",
						},
					],
					providerAbbr: [
						{
							required: true,
							message: "请输入供应商简称",
							trigger: "blur",
						},
					],
					validityCache: [
						{
							required: true,
							message: "请填入合同时间",
							trigger: "blur",
						},
					],
					dockingMode: [
						{
							required: true,
							message: "请选择对接方式",
							trigger: "change",
						},
					],
					providerStatus: [
						{
							required: true,
							message: "请选择状态",
							trigger: "change",
						},
					],
					ocrRequired: [
						{ required: true, message: "请选择", trigger: "change" },
					],
					contactExt: [
						{
							name: [
								{
									required: true,
									message: "请输入商务联系人",
									trigger: "blur",
								},
							],
							mobile: [
								{
									required: true,
									validator: checkPhone,
									trigger: "blur",
								},
							],
							email: [{ validator: checkEmail, trigger: "blur" }],
						},
						{
							name: [{ required: false }],
							mobile: [{ validator: checkPhone, trigger: "blur" }],
							email: [{ validator: checkEmail, trigger: "blur" }],
						},
						{
							name: [{ required: false }],
							mobile: [{ validator: checkPhone, trigger: "blur" }],
							email: [{ validator: checkEmail, trigger: "blur" }],
						},
					],
				},
				providerId: "", // 当前id
				submitLoading: false,
				/**
				 * 批量导入供应商 -- 弹窗相关 **/
				path: process.env.BASE_URL,
				uploadHeader: { token: db.get("ACCESS_TOKEN") }, //上传header
				uploadFile: null, //上传后文件
				uploadAction: "", //提交表单地址
				dialogVisibleImport: false, // 弹窗是否展示
				templateForm: {
					tempFile: "",
				},
				showImportFail: false, //导入错误提示弹框
				errorData: {},
			};
		},

		created() {
			this.$root.breadList = [
				{ name: "供应商", link: "" },
				{ name: "供应商管理", link: "" },
			];
		},
		mounted() {
			this.$nextTick(() => {
				this.getData(); // 获取供应商列表
				this.uploadAction = this.getApiUrl("postProviderImport");
			});
		},
		computed: {
			...mapGetters(["userName"]),
		},
		methods: {
			providerStatusFN(row) {
				const endTime = new Date(row.contractEndTime).getTime();
				const systemTime = new Date(row.systemTime).getTime();
				const end = endTime * 1 - systemTime * 1;

				let fontColor = "";
				if (end < 60 * 24 * 60 * 60 * 1000) {
					fontColor = "fontO";
				} else {
					fontColor = "";
				}
				return fontColor;
			},
			// 列表时间 重新计算展示格式
			handlingTime(row) {
				let timeStart = _.get(row, "contractStartTime", " ")
					.split(" ")[0]
					.replace(/-/g, "/");
				let timeEnd = _.get(row, "contractEndTime", " ")
					.split(" ")[0]
					.replace(/-/g, "/");

				return timeStart + "至" + timeEnd;
			},
			/**
			 * 窗口改变重新获取高度
			 */
			listenWindow() {
				this.tableHeight = this.$refs.tableBox.offsetHeight;
				window.addEventListener("resize", () => {
					clearTimeout(this.resizeFlag);
					this.resizeFlag = setTimeout(() => {
						try {
							this.tableHeight =
								this.$refs.tableBox.offsetHeight || 0;
						} catch (e) {}
					}, 300);
				});
			},
			getReceive(data) {
				this[data.key] = data.value;
			},
			/**
			 * 批量导入供应商
			 */
			// -- 文件上传确定按钮
			sureSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						if (!this.uploadFile) {
							this.$message.warning("请选择文件");
							return;
						}
						//数据确认
						this.$refs["upload-dom"].submit();
					} else {
						return false;
					}
				});
			},
			//文件状态改变时
			uploadChange(file) {
				this.uploadFile = file;
			},
			//文件移除前
			uploadBeforeRemove(file) {
				return this.$confirm(`确定移除 ${file.name}？`);
			},
			//文件上传前
			uploadBefore(file) {
				const isLt10M = file.size / 1024 / 1024 < 10;
				if (!isLt10M) {
					this.$message.error("上传文件不能超过 10MB!");
				}
				return isLt10M;
			},
			//文件移除
			uploadHandleRemove() {
				this.uploadFile = null;
				this.$refs["upload-dom"].clearFiles();
			},
			//文件上传成功
			uploadSucess(res) {
				let { code, msg } = res;
				if (code == 1) {
					this.doErrorData(res.data);
				} else {
					this.$message.error(msg);
				}
				this.uploadHandleRemove();
			},
			doErrorData(res) {
				if (res.failList && res.failList.length == 0) {
					this.$message({
						type: "success",
						message: "导入成功",
					});
					this.dialogVisibleImport = false;
				} else {
					res.failList = res.failList.map((item) => {
						return Object.keys(item).map((el) => {
							return {
								value: el,
								label: item[el],
							};
						})[0];
					});
					res.fileName = "供应商导入失败信息表";
					res.headerData = 1;
					this.errorData = res;
					this.showImportFail = true;
				}
				this.getData();
			},
			changeValue(arr) {
				// console.log(arr)
			},
			// 关闭批量导入供应商弹窗
			toCloseDialogImport() {
				this.uploadFile = null;
				this.dialogVisibleImport = false;
				this.$refs["upload-dom"].clearFiles();
				this.$refs["templateForm"].resetFields();
			},
			/**
			 * 删除供应商（预留函数）
			 */
			deletHandle(row) {
				this.$confirm("确认删除当前供应商?", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning",
				})
					.then(() => {
						this.$message({
							type: "success",
							message: "删除成功!",
						});
					})
					.catch(() => {
						this.$message({
							type: "info",
							message: "已取消删除",
						});
					});
			},
			goWebsite(row) {
				this.$router.push({
					name: "WebsiteManager",
					query: {
						id: row.id,
						providerAbbr: row.providerAbbr,
					},
				});
			},
			goService(row) {
				this.$router.push({
					name: "ServiceManager",
					query: {
						id: row.id,
						providerAbbr: row.providerAbbr,
					},
				});
			},
			searchData() {
				this.searchBox.pageNo = 1;
				this.clrearTipid();
				this.getData();
			},
			clrearTipid() {
				this.searchBox.providerId = "";
			},
			getData() {
				this.loading = true;
				let params = Object.assign(
					{},
					this.searchBox,
					this.getAreaIdObj(this.searchBox)
				);
				this.axios
					.get(this.getApiUrl("providerPage"), {
						params,
					})
					.then((res) => {
						this.loading = false;

						if (res.code === 1) {
							this.tableData = res.data.data || [];
							this.total = res.data.total;
							if (params.providerId) {
								this.searchBox.keyword =
									res.data.data[0].providerName;
							}
						} else {
							this.$message.warning(res.msg);
						}
						this.listenWindow();
					})
					.catch((err) => {
						this.loading = false;
					});
			},
			/**
			 * 时间回调函数
			 */
			toChangeTime(val) {
				if (val && val.length) {
					this.searchBox.contractStartTime = val[0];
					this.searchBox.contractEndTime = val[1];
				} else {
					this.searchBox.contractStartTime = "";
					this.searchBox.contractEndTime = "";
				}
			},
			/**
			 * 时间回调函数
			 */
			toChangeTimeAdd(val) {
				if (val && val.length) {
					this.formData.contractStartTime = val[0];
					this.formData.contractEndTime = val[1];
				} else {
					this.formData.contractStartTime = "";
					this.formData.contractEndTime = "";
				}
			},
			// 下载倒入供应商模版
			downloadTemp() {
				let urlPath = this.getApiUrl("downLoadProviderImport");
				this.$root.exportFile(urlPath, {}, "供应商信息导入模板");
			},
			// 导出供应商
			exportSupplier() {
				let urlPath = this.getApiUrl("postProviderExport");
				let date = dateFormat(new Date());
				let query = Object.assign(
					{},
					this.searchBox,
					this.getAreaIdObj(this.searchBox)
				);
				let param = this.$root.optionProcess(
					JSON.parse(JSON.stringify(query))
				);
				delete param.pageNo;
				delete param.pageSize;
				if (param.areaId) delete param.areaId;
				let fileName = `供应商信息表${date.replace(/-/g, "").slice(0, 8)}${
					this.userName
				}`;
				this.$root.exportFile(urlPath, param, fileName);
			},
			handleCurrentChange(val) {
				this.searchBox.pageNo = val;
				this.getData();
			},
			handleSizeChange(val) {
				this.searchBox.pageNo = 1;
				this.searchBox.pageSize = val;
				this.getData();
			},
			// -- 启用 && 停用
			changeStatus(row) {
				var message = "",
					status = row.providerStatus;
				if (status == "ON") {
					message = "停用成功";
				} else {
					message = "启用成功";
				}
				if (status == "ON") {
					this.$confirm(
						status == "ON"
							? "您是否确定停用?"
							: "供应商合同已到期，请修改合同时间在进行操作",
						"提示",
						{
							confirmButtonText: "",
							cancelButtonText: "取消",
							type: "warning",
						}
					)
						.then(() => {
							let params = {
								id: row.id,
								status: status == "ON" ? "OFF" : "ON",
							};
							this.axios
								.post(
									this.getApiUrl("postProviderStatus"),
									params,
									{
										toJSON: true,
									}
								)
								.then((res) => {
									if (res.code == 1) {
										this.$message({
											type: "success",
											message: message,
										});
										this.getData();
									} else {
										this.$message.warning(res.msg);
									}
								});
						})
						.catch(() => {
							this.$message({
								type: "info",
								message: "已取消操作",
							});
						});
				} else {
					this.$alert(`供应商合同已到期，请修改合同时间在进行操作`);
				}
			},
			/**
			 * 新建、查看、修改角色 相关开始 -------**/
			toAdd(row, dialogType) {
				this.dialogType = dialogType;
				this.formData = {
					providerName: "",
					providerAbbr: "",
					dockingMode: "",
					providerStatus: "ON",
					ocrRequired: "YES",
					providerDesc: "",
					providerAddress: "",
					contractStartTime: "",
					contractEndTime: "",
					validityCache: "",
					contactExt: [{ name: "", mobile: "", email: "" }],
				};

				if (this.$refs["form"]) {
					this.$refs["form"].resetFields();
				}
				if (dialogType == 1) {
					this.dialogTitle = "新建供应商";
					this.dialogVisibleAdd = true;
					this.providerId = "";
				} else {
					this.providerId = row.id;

					if (dialogType == 0) this.dialogTitle = "查看供应商";
					else if (dialogType == 2) this.dialogTitle = "编辑供应商";

					this.axios
						.get(this.getApiUrl("postProviderView"), {
							params: {
								providerId: row.id,
							},
						})
						.then((res) => {
							this.loading = false;
							if (res.code === 1) {
								if (
									res.data.contactExt == null ||
									res.data.contactExt.length == 0
								) {
									res.data.contactExt = [
										{ name: "", mobile: "", email: "" },
									];
								}
								if (
									res?.data?.contractEndTime &&
									res?.data?.contractStartTime
								) {
									res.data.validityCache = [
										new Date(
											res.data.contractStartTime.replaceAll(
												"-",
												"/"
											)
										).getTime(),
										new Date(
											res.data.contractEndTime.replaceAll(
												"-",
												"/"
											)
										).getTime(),
									];

									this.$nextTick(() => {
										this.toChangeTimeAdd(
											res.data.validityCache
										);
									});
								}
								this.formData = res.data;
								this.dialogVisibleAdd = true;
							} else {
								this.$message.warning(res.msg);
							}
						})
						.catch((err) => {
							this.loading = false;
						});
				}
			},
			addSupplier() {
				this.$refs["form"].validate((valid) => {
					if (!valid) {
						return false;
					}
					this.clrearTipid();
					if (this.providerId) {
						// 修改
						let p = {
							...this.formData,
							id: this.providerId,
						};
						this.addSupplierFn("postProviderEdit", p);
					} else {
						this.clrearTipid();
						this.addSupplierFn("postProviderCreate", this.formData);
					}
				});
			},

			addSupplierFn(url, param) {
				this.submitLoading = true;
				this.axios
					.post(this.getApiUrl(url), param, { toJSON: true })
					.then((res) => {
						this.submitLoading = false;
						if (res.code === 1) {
							this.$message.success("操作成功");
							this.dialogVisibleAdd = false;
							this.getData();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch((err) => {
						this.submitLoading = false;
					});
			},
			// 添加联系人
			addContact() {
				if (this.formData.contactExt.length < 3) {
					this.formData.contactExt.push({
						name: "",
						mobile: "",
						email: "",
						key: new Date(),
					});
				}
			},
			// 删除联系人
			removeContact(inx) {
				this.formData.contactExt.splice(inx, 1);
			},
			toCloseDialog() {
				this.$refs["form"].resetFields();
				this.dialogVisibleAdd = false;
				this.formData = {
					providerName: "",
					providerAbbr: "",
					dockingMode: "",
					providerStatus: "ON",
					ocrRequired: "YES",
					providerDesc: "",
					providerAddress: "",
					validityCache: "",
					contactExt: [{ name: "", mobile: "", email: "" }],
				};
			},
			/**
			 * 新建、查看、修改角色 相关结束 -------**/
		},

		beforeRouteLeave(to, from, next) {
			if (to.name != "ServiceManager" && to.name != "WebsiteManager") {
				this.searchBox = {
					keyword: "", // 模糊查询
					status: "", // 状态
					providerIdSet: "",
					timeRange: [],
					pageNo: 1, // 页码
					pageSize: 10,
				};
				this.getData();
				to.meta.keepAlive = false;
			}

			next(true);
		},
	};
</script>

<style lang="scss" scoped type="text/scss">
	.fontO {
		color: #ffa93b;
	}
	.fontR {
		color: #d9001b;
	}
	.no-a {
		color: #fff;
		text-decoration: none;
	}
	.edit-dialog .el-input {
		width: 100%;
	}
</style>
<style lang="scss">
	.el-message-box_style {
		.el-message-box__title {
			color: #f56c6c !important;
		}
	}
	.el-tooltip__popper {
		max-width: 200px;
	}
</style>
